/**
 * Kodapixel global layout (header, announcement, footer)
 * Listens on document for Horizon cart:update
 */
(function () {
  if (window.__kpLayoutInit) return;
  window.__kpLayoutInit = true;

  const CART_EVENT = 'cart:update';

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /* ── Cart count ── */
  function setCartCount(n) {
    qsa(document, '[data-kp-cart-count]').forEach((el) => {
      el.textContent = String(n);
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      setCartCount(cart.item_count || 0);
    } catch (_) {}
  }

  document.addEventListener(CART_EVENT, () => {
    refreshCartCount();
  });

  function initHomeFoldHeights() {
    if (!document.body.classList.contains('kp-home-page')) return;
    const announce = document.querySelector('.kp-announcement');
    const header = document.querySelector('.kp-header');
    const trust =
      document.querySelector('.kp-hero-section .kp-trust-bar') ||
      document.querySelector('.kp-trust-bar-section');
    const root = document.body;
    if (announce) {
      root.style.setProperty('--kp-home-announce-h', `${announce.offsetHeight}px`);
    }
    if (header) {
      root.style.setProperty('--kp-home-nav-h', `${header.offsetHeight}px`);
    }
    if (trust) {
      root.style.setProperty('--kp-home-trust-h', `${trust.offsetHeight}px`);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    refreshCartCount();
    initHomeFoldHeights();
    window.addEventListener('resize', initHomeFoldHeights);
  });

  /* ── Cart drawer (KP header + kp-cart-drawer section) ── */
  document.addEventListener('click', (e) => {
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const trigger = e.target.closest('[data-kp-cart-open]');
    if (!trigger) return;
    const drawer = document.getElementById('kp-cart-drawer');
    if (!drawer) return;
    e.preventDefault();
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      customElements.whenDefined('cart-drawer-component').then(() => {
        if (typeof drawer.open === 'function') drawer.open();
      });
    }
  });

  /* ── Announcement rotate ── */
  function initAnnouncementRotate(root) {
    const items = qsa(root, '.kp-announcement__rotate-item');
    if (items.length < 2) return;
    const speed = parseInt(root.getAttribute('data-kp-rotate-ms'), 10) || 5000;
    let i = 0;
    items.forEach((el, idx) => el.classList.toggle('is-active', idx === 0));
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  }

  /* ── Header drawer ── */
  function initHeader(header) {
    const toggle = qs(header, '[data-kp-nav-toggle]');
    const drawer = qs(header, '[data-kp-drawer]');
    const backdrop = qs(header, '[data-kp-drawer-backdrop]');
    const closeBtn = qs(header, '[data-kp-drawer-close]');

    if (!toggle || !drawer) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('kp-no-scroll', open);
    }

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      setOpen(open);
    });

    if (backdrop) backdrop.addEventListener('click', () => setOpen(false));
    if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));

    /* Mobile drawer parent accordion */
    qsa(header, '[data-kp-drawer-parent] > a').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(min-width: 1025px)').matches) return;
        const li = link.closest('[data-kp-drawer-parent]');
        if (!li || !qs(li, '.kp-header__drawer-sub')) return;
        e.preventDefault();
        li.classList.toggle('kp-is-open');
      });
    });
  }

  /* ── Sticky hide on scroll ── */
  function initScrollHide(header) {
    let last = 0;
    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const y = window.scrollY || 0;
          const down = y > last && y > 80;
          header.classList.toggle('kp-header--hidden', down);
          last = y;
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    qsa(document, '[data-kp-announcement]').forEach((ann) => {
      if (ann.classList.contains('kp-announcement--rotate')) initAnnouncementRotate(ann);
    });

    qsa(document, '[data-kp-header]').forEach((header) => {
      initHeader(header);
      if (header.hasAttribute('data-kp-scroll-hide')) initScrollHide(header);
    });
  });
})();
